import styled from 'styled-components'
import { COLORS } from 'utils'

export const CardContainer = styled.div`
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  width: 100%;
  height: 20rem;
`
export const ContenctCard = styled.div`
  padding: 4px 0;
  overflow: auto;
  height: 95%;
`

export const ItemList = styled.li`
  list-style: none;
  margin: 0.75rem 0;
  cursor: pointer;
`
export const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const LineTop = styled.div`
  background: ${COLORS.primary};
  height: 8px;
  width: 100%;
  border-radius: 4px 4px 0 0;
`
